<template>
  <qc-container title="订单管理">
    <page-request ref="table" url="/api/mgr/shop/business/order/list" :table-header="tableHeader" :expend="expend" :prop="{orderType:0,status:activeName}" :op-width="200">
      <div class="flex-cc full">
        <el-tabs v-model="activeName">
          <el-tab-pane label="全部" name=""></el-tab-pane>
          <el-tab-pane label="待付款" name="0"></el-tab-pane>
          <el-tab-pane label="待发货" name="1"></el-tab-pane>
          <el-tab-pane label="待收货" name="2"></el-tab-pane>
          <el-tab-pane label="待评价" name="3"></el-tab-pane>
          <el-tab-pane label="已完成" name="4"></el-tab-pane>
          <el-tab-pane label="已关闭" name="5"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <export-excel @action="addExportTask" ref="exportExcel" file-name="shop-order-export.xlsx" task-key="order" task-name="商城订单列表" button-name="批量导出"></export-excel>
        </div>
      </div>
      <template #op="scope">
        <b-button @click="orderDetail(scope.row.id)">详情</b-button>
      </template>
    </page-request>


    <order-info ref="orderInfo"></order-info>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import OrderInfo from "@view/order/op/order-info.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";

export default {
  name: "on-line-order",
  components: {ExportExcel, OrderInfo, PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      activeName:"",
      tableHeader: [
        {type: "orderInfo", label: "订单",minWidth:220},
        {type: "goodsList", label: "商品",prop:"orderGoodsList",minWidth:400},
        {type: "delivery",label: "买家/收货人",width: 300},
        {prop: "payMoney", label: "金额",width:100},
        {label: "状态",width:100,renderDraw:(row)=>{
            return this.getOrderStatus(row);
          }},
        {prop: "payTime", label: "付款时间",width:160},
        {prop: "createTime", label: "下单时间",width:160},
      ],
      expend: [
        {label: "商品名称", prop: "goodsName"},
        {label: "商品编码", prop: "goodsCodes"},
        {label: "订单编号", prop: "code"},
        {label: "订单类型", prop: "goodsType",type:"select",options:[{"label":"售卖","value":"0"},{"label":"租赁","value":"1"},{"label":"洗消","value":"1"}]},
        {label: "收货人", prop: "deliveryName"},
        {label: "收货电话", prop: "mobile"},
        {label: "收货地址", prop: "address"},
        {label: "商家名称", prop: "shopName"},
        {label: "商家电话", prop: "shopMobile"},
        {label: "下单时间", start: "startTime", end: "endTime", type: "daterange"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    orderDetail(id){
      this.$refs.orderInfo.openDrawer(id);
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
